export default __webpack_public_path__ + "static/media/Ibad Shaikh.7d4b8e3e.jpg";